export const MAIN = {
  PRIMARY: "#003366",
  SECONDARY: "#3DBAD2",
  TERTIARY: "#3CA949",
};

export default {
  MAIN,
};
